<script lang="ts">
	import { page } from '$app/state';
	import { pathMatch } from '$lib/utils';
	import { some } from 'lodash-es';
	import { ChevronDown } from 'lucide-svelte';

	interface Props {
		navItems: NavItem[];
	}

	let { navItems }: Props = $props();
</script>

<ul class="hidden text-black md:gap-7 lg:flex lg:items-center">
	{#each navItems as navItem}
		{#if navItem.children}
			<li class="group relative flex items-center gap-1">
				<span
					class="group-hover:text-green-primary"
					class:active={some(navItem.children, ({ url }) => pathMatch(page.url.pathname, url))}
				>
					{navItem.label}
				</span>
				<ChevronDown class="w-6" />
				<ul
					class="bg-white-pure absolute top-full left-0 hidden flex-col gap-4 overflow-visible rounded-2xl p-4 whitespace-nowrap drop-shadow group-hover:flex"
				>
					{#each navItem.children as navChild}
						<li class="flex h-full items-center">
							<a
								class="nav-item"
								href={navChild.url}
								class:active={pathMatch(page.url.pathname, navChild.url, navChild.exact)}
							>
								{navChild.label}
							</a>
						</li>
					{/each}
				</ul>
			</li>
		{:else}
			<li>
				<a
					class:active={pathMatch(page.url.pathname, navItem.url ?? '', navItem.exact)}
					class="nav-item"
					href={navItem.url}
				>
					{navItem.label}
				</a>
			</li>
		{/if}
	{/each}
</ul>

<style lang="postcss">
	@reference '../../app.css';

	.active {
		@apply text-green-primary font-medium;
	}

	:global(.nav-item) {
		@apply relative;

		&:after {
			content: '';
			@apply absolute -bottom-1 left-0 h-[2px] w-full rounded;
		}
		&:hover {
			@apply text-green-primary;

			&:after {
				@apply bg-green-primary;
			}
		}
	}
</style>
